/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_view_items = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Ver ${i.count}`
};

const en_accounts_view_items = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `View ${i.count}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_view_items = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_view_items(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_view_items", locale)
	if (locale === "es") return es_accounts_view_items(inputs)
	return en_accounts_view_items(inputs)
};
export { accounts_view_items as "accounts.view_items" }